import type { RouteObject } from 'react-router-dom';
import NotFound from '@/pages/NotFound';
import PrivacyPolicyPage from '@/pages/privacy/page';
import EnPrivacyPolicyPage from '@/pages/en/privacy/page';
import JaPrivacyPolicyPage from '@/pages/ja/privacy/page';
import TermsOfUsePage from '@/pages/terms/page';
import EnTermsOfUsePage from '@/pages/en/terms/page';
import JaTermsOfUsePage from '@/pages/ja/terms/page';
import HomePage from '@/pages/home/page';
import EnHomePage from '@/pages/en/page';
import JaHomePage from '@/pages/ja/page';
import JaSubPage from '@/pages/ja/SubPage';
// Japanese sub-pages
import JaHomeSubPage from '@/pages/ja/home/SubPage';
import JaAboutPage from '@/pages/ja/about/page';
import JaAboutSubPage from '@/pages/ja/about/SubPage';
import JaPartnershipPage from '@/pages/ja/partnership/page';
import JaCoopSubPage from '@/pages/ja/cooperation/SubPage';
import JaServicesPage from '@/pages/ja/services/page';
import JaServicesSubPage from '@/pages/ja/services/SubPage';
import JaContactPage from '@/pages/ja/contact/page';
import JaContactFormPage from '@/pages/ja/contact/FormPage';
import JaContactInfoPage from '@/pages/ja/contact/InfoPage';
// English sub-pages
import EnAboutPage from '@/pages/en/about/page';
import EnAboutSubPage from '@/pages/en/about/SubPage';
import EnCoopSubPage from '@/pages/en/cooperation/SubPage';
import EnServicesPage from '@/pages/en/services/page';
import EnServicesSubPage from '@/pages/en/services/SubPage';
import EnPartnershipPage from '@/pages/en/partnership/page';
import EnContactPage from '@/pages/en/contact/page';
import EnContactFormPage from '@/pages/en/contact/FormPage';
import EnContactInfoPage from '@/pages/en/contact/InfoPage';
import EnHomeSubPage from '@/pages/en/home/SubPage';
// Chinese pages
import CorePage from '@/pages/home/CorePage';
import AdvantagesPage from '@/pages/home/AdvantagesPage';
import ExperiencePage from '@/pages/home/ExperiencePage';
import HomeHotFormulasPage from '@/pages/home/HomeHotFormulasPage';
import AboutPage from '@/pages/about/page';
import CoreAdvantagesPage from '@/pages/about/CoreAdvantagesPage';
import ProductionPage from '@/pages/about/ProductionPage';
import CasesPage from '@/pages/about/CasesPage';
import RegulationPage from '@/pages/about/RegulationPage';
import PartnershipPage from '@/pages/partnership/page';
import ProcessPage from '@/pages/cooperation/ProcessPage';
import CoopServicesPage from '@/pages/cooperation/ServicesPage';
import FaqPage from '@/pages/cooperation/FaqPage';
import InquiryPage from '@/pages/cooperation/InquiryPage';
import ServicesPage from '@/pages/services/page';
import HotFormulasPage from '@/pages/services/HotFormulasPage';
import NaturalIngredientsPage from '@/pages/services/NaturalIngredientsPage';
import DosageFormsPage from '@/pages/services/DosageFormsPage';
import PackagingPage from '@/pages/services/PackagingPage';
import ContactPage from '@/pages/contact/page';
import ContactFormPage from '@/pages/contact/FormPage';
import ContactInfoPage from '@/pages/contact/InfoPage';

const routes: RouteObject[] = [
  // ── Chinese routes ─────────────────────────────
  { path: '/', element: <HomePage /> },
  { path: '/home/core', element: <CorePage /> },
  { path: '/home/advantages', element: <AdvantagesPage /> },
  { path: '/home/experience', element: <ExperiencePage /> },
  { path: '/home/hot-formulas', element: <HomeHotFormulasPage /> },
  { path: '/about', element: <AboutPage /> },
  { path: '/about/core-advantages', element: <CoreAdvantagesPage /> },
  { path: '/about/production', element: <ProductionPage /> },
  { path: '/about/cases', element: <CasesPage /> },
  { path: '/about/regulation', element: <RegulationPage /> },
  { path: '/partnership', element: <PartnershipPage /> },
  { path: '/cooperation/process', element: <ProcessPage /> },
  { path: '/cooperation/services', element: <CoopServicesPage /> },
  { path: '/cooperation/faq', element: <FaqPage /> },
  { path: '/cooperation/inquiry', element: <InquiryPage /> },
  { path: '/services', element: <ServicesPage /> },
  { path: '/services/hot-formulas', element: <HotFormulasPage /> },
  { path: '/services/natural-ingredients', element: <NaturalIngredientsPage /> },
  { path: '/services/dosage-forms', element: <DosageFormsPage /> },
  { path: '/services/packaging', element: <PackagingPage /> },
  { path: '/contact', element: <ContactPage /> },
  { path: '/contact/form', element: <ContactFormPage /> },
  { path: '/contact/info', element: <ContactInfoPage /> },
  // ── English routes ─────────────────────────────
  { path: '/en', element: <EnHomePage /> },
  { path: '/en/home/core', element: <EnHomeSubPage /> },
  { path: '/en/home/advantages', element: <EnHomeSubPage /> },
  { path: '/en/home/experience', element: <EnHomeSubPage /> },
  { path: '/en/home/hot-formulas', element: <EnHomeSubPage /> },
  { path: '/en/about', element: <EnAboutPage /> },
  { path: '/en/about/core-advantages', element: <EnAboutSubPage /> },
  { path: '/en/about/production', element: <EnAboutSubPage /> },
  { path: '/en/about/cases', element: <EnAboutSubPage /> },
  { path: '/en/about/regulation', element: <EnAboutSubPage /> },
  { path: '/en/partnership', element: <EnPartnershipPage /> },
  { path: '/en/cooperation/process', element: <EnCoopSubPage /> },
  { path: '/en/cooperation/services', element: <EnCoopSubPage /> },
  { path: '/en/cooperation/faq', element: <EnCoopSubPage /> },
  { path: '/en/cooperation/inquiry', element: <EnCoopSubPage /> },
  { path: '/en/services', element: <EnServicesPage /> },
  { path: '/en/services/hot-formulas', element: <EnServicesSubPage /> },
  { path: '/en/services/natural-ingredients', element: <EnServicesSubPage /> },
  { path: '/en/services/dosage-forms', element: <EnServicesSubPage /> },
  { path: '/en/services/packaging', element: <EnServicesSubPage /> },
  { path: '/en/contact', element: <EnContactPage /> },
  { path: '/en/contact/form', element: <EnContactFormPage /> },
  { path: '/en/contact/info', element: <EnContactInfoPage /> },
  // ── Japanese routes ──────────────────────────────
  { path: '/ja', element: <JaHomePage /> },
  { path: '/ja/home/core', element: <JaHomeSubPage /> },
  { path: '/ja/home/advantages', element: <JaHomeSubPage /> },
  { path: '/ja/home/experience', element: <JaHomeSubPage /> },
  { path: '/ja/home/hot-formulas', element: <JaHomeSubPage /> },
  { path: '/ja/about', element: <JaAboutPage /> },
  { path: '/ja/about/core-advantages', element: <JaAboutSubPage /> },
  { path: '/ja/about/production', element: <JaAboutSubPage /> },
  { path: '/ja/about/cases', element: <JaAboutSubPage /> },
  { path: '/ja/about/regulation', element: <JaAboutSubPage /> },
  { path: '/ja/partnership', element: <JaPartnershipPage /> },
  { path: '/ja/cooperation/process', element: <JaCoopSubPage /> },
  { path: '/ja/cooperation/services', element: <JaCoopSubPage /> },
  { path: '/ja/cooperation/faq', element: <JaCoopSubPage /> },
  { path: '/ja/cooperation/inquiry', element: <JaCoopSubPage /> },
  { path: '/ja/services', element: <JaServicesPage /> },
  { path: '/ja/services/hot-formulas', element: <JaServicesSubPage /> },
  { path: '/ja/services/natural-ingredients', element: <JaServicesSubPage /> },
  { path: '/ja/services/dosage-forms', element: <JaServicesSubPage /> },
  { path: '/ja/services/packaging', element: <JaServicesSubPage /> },
  { path: '/ja/contact', element: <JaContactPage /> },
  { path: '/ja/contact/form', element: <JaContactFormPage /> },
  { path: '/ja/contact/info', element: <JaContactInfoPage /> },
  // ── Legal routes ──────────────────────
  { path: '/privacy-policy', element: <PrivacyPolicyPage /> },
  { path: '/en/privacy-policy', element: <EnPrivacyPolicyPage /> },
  { path: '/ja/privacy-policy', element: <JaPrivacyPolicyPage /> },
  { path: '/terms-of-use', element: <TermsOfUsePage /> },
  { path: '/en/terms-of-use', element: <EnTermsOfUsePage /> },
  { path: '/ja/terms-of-use', element: <JaTermsOfUsePage /> },
  { path: '*', element: <NotFound /> },
];

export default routes;
